import { Component, ChangeDetectionStrategy, ViewChild, ViewContainerRef, Type } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { NgAfterViewInit } from '@cikrf/gas-utils/decorators';
import { GasDynamicComponentsService } from '@cikrf/gas-utils/services';
import { BaseComponent } from '@cikrf/gas-utils/services/gas-dynamic-components.service';

import { GasHeaderService } from './gas-header.service';

/**
 * @description
 * Шапка для сайта, используется в лейауте, для управления используется gasHeaderService
 */
@Component({
  selector: 'gas-header',
  templateUrl: './gas-header.component.html',
  styleUrls: ['./gas-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasHeaderComponent {
  @NgAfterViewInit()
  public afterViewInit$!: Observable<void>;

  @ViewChild('containeRef', { read: ViewContainerRef })
  public containeRef: ViewContainerRef;

  public title$ = this.gasHeaderService.title$;
  public subtitle$ = this.gasHeaderService.subtitle$;
  public icon$ = this.gasHeaderService.icon$;
  public iconColor$ = this.gasHeaderService.iconColor$;
  public iconClass$ = this.gasHeaderService.iconClass$;
  public breadcrumbs$ = this.gasHeaderService.breadcrumbs$;
  public component$ = this.gasHeaderService.component$;

  constructor(
    private gasHeaderService: GasHeaderService,
    private gasDynamicComponentService: GasDynamicComponentsService,
  ) {
    combineLatest([
      this.afterViewInit$,
      this.component$,
    ])
      .subscribe(([nothing, component]: [undefined, Type<BaseComponent>]) => {

        const componentRef = this.gasDynamicComponentService.createChildComponent(component, this.containeRef);

        // TODO: Разобраться почему не рендерится без detectChanges
        componentRef.changeDetectorRef.detectChanges();

        this.gasHeaderService.setComponentRef(componentRef);
      });
  }
}
